<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p0 uca-payeezy-payment-wrapper">
    <div id="paymentFrame"></div>

</div>

<div class="terms-condition-submit-section mt-3">
    <div class="row" id="fpassTermsSection">
        <div class="col-12 form-group">
            <div class="check-box-label">
                By selecting the button below, you agree to the&nbsp;
                <button
                        #openFreshpassTermButton
                        (click)="openTerms(userSubscriptionDetails, userInfo, openFreshpassTermButton)"
                        class="sub-termsunderline-text"
                        role="link"
                        tabindex="0">
                    {{PROGRAM_DISPLAY_NAME}} Terms&nbsp;
                </button>
                and authorize charges to your selected payment method for the subscription and for subsequent
                auto-renewal payments until you cancel.

            </div>
            <div class="help-block with-errors"></div>
        </div>
    </div>


    <div class="row ds-disclaimer-section">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

        </div>
    </div>

    <div class="red fs18" id="ds-banner-submit-error"></div>
    <div class="text-left loading-div-tiny mask" id="ds-banner-submit-busy-loading">
        <div class="loading-spinner">
            <div alt="Loading..." class="small progress">
                <div class="prog1">
                    <div class="prog2"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="row button-wrapper update-button container">
        <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
            <div *ngIf="isUpdating">
              <div class="loading-spinner">
                <div alt="Loading..." class="small progress">
                    <div class="prog1">
                        <div class="prog2"></div>
                    </div>
                </div>
              </div>
            </div>
            <div *ngIf="!isUpdating">
              <button [disabled]="isUpdating" (click)="updateSubscriptionPlan()" (keydown.enter)="updateSubscriptionPlan()" class="pds-btn pds-btn-filled--primary pds-btn-size__medium" role="button"
                      type="submit">
                  {{programDisplayData?.paymentModel?.update}}
              </button>
            </div>
        </div>
    </div>
</div>




